import { PAY_GATEWAY } from '@/hooks/use-pay/types';

import { ETrackerEvents, trackCustom } from '../index';

import { formatTrackerMoney, type IRechargePayExtras } from './recharge-result';

const DEFAULT_GATEWAY_NAME = PAY_GATEWAY.PAYPAL;

/** 第三方支付面板成功拉起并在屏幕展现时上报 */
export function trackGatewayShow(params: {
    order_id: string;
    gear_id: string;
    payExtras: Pick<IRechargePayExtras, 'money' | 'goods_type' | 'order_from'>;
    payment_method: string;
    gateway_name?: string;
    /** 页面级触发场景（与 staticContext 同源）；弹窗直拉为 recharge_pop_up */
    trigger_scene?: string;
    paywall_style: string;
}): void {
    const {
        order_id,
        gear_id,
        payExtras,
        payment_method,
        gateway_name = DEFAULT_GATEWAY_NAME,
        trigger_scene,
        paywall_style,
    } = params;
    if (!order_id?.trim()) {
        return;
    }

    const payload: Record<string, string | number> = {
        order_id,
        gateway_name,
        gear_id,
        goods_type: payExtras.goods_type,
        money: formatTrackerMoney(payExtras.money),
        payment_method,
        paywall_style,
    };
    if (trigger_scene) {
        payload.trigger_scene = trigger_scene;
    }
    // BI_TRACK_ORDER_FROM_FIELD：活动商品来源（若 BI 改名同步替换 key）
    if (payExtras.order_from) {
        payload.order_from = payExtras.order_from;
    }

    trackCustom(ETrackerEvents.GATEWAY_SHOW, payload);
}
